import React from 'react';
import { injectIntl } from 'react-intl';
import { hasBlocksData, getBaseUrl } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { isEqual } from 'lodash'; 


const SubcoverView = (props) => {
  const { content, location } = props;
  const path = getBaseUrl(location?.pathname || '');
  const contentLoaded = content && !isEqual(Object.keys(content), ['lock']);

  return contentLoaded && (
    <>
      <div id="page-document" className='pageDocument'>
        {hasBlocksData(content) && (
          <div className="pageBlocks pageDocument__blocks">
            <RenderBlocks {...props} path={path} />
          </div>
        )}
      </div>
    </>
  );
};

export default injectIntl(SubcoverView);
